import { useAuth } from "~/context/AuthContext";

export default function useIsEcommerce() {
  const { user } = useAuth();
  return Boolean(
    user?.teams?.find((team) => String(team.id) === String(user?.team_id))
      ?.is_ecommerce
  );
}
